import isSame from './isSame'
export default isSame
